<template>
  <v-tooltip bottom>
    <template #activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        icon
        small
        v-bind="attrs"
        v-on="on"
        @click="_ => openQuickInterviewDiff()"
      >
        <v-icon small>
          mdi-eye-outline
        </v-icon>
      </v-btn>
    </template>
    View Changes
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'

export default {
  name: 'ViewQuickInterviewChangesIconButton',

  props: {
    interviewId: {
      type: Number,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      isLoading: false,
    }
  },

  computed: {
    quickInterview () {
      return this.quickInterviewsList.find(qi => qi.id === this.interviewId)
    },

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterviewsList',
    ]),
  },

  methods: {
    openQuickInterviewDiff () {},
  },
}
</script>
